'use client';

import React from 'react';
import { TasticProps } from '../types';
import ShippingBanner from 'components/commercetools-ui/organisms/shipping-banner';
import { ShippingBannerPayload } from 'types/next';
import useMobileDevice from 'helpers/hooks/useMobileDevice';
import { useTablet } from 'helpers/hooks/useTabletDevice';
import useLocale from 'helpers/hooks/useLocale';

const ShippingBannersTastic = ({ data }: TasticProps<ShippingBannerPayload>) => {
  const { isMobileDevice } = useMobileDevice();
  const isTablet = useTablet();
  const { getCurrency } = useLocale();
  const selectedLocale = getCurrency() === 'GBP' ? 'en-GB' : 'en-EU';
  const parentMobile = data?.mobile ?? true;
  const parentTablet = data?.tablet ?? true;
  const parentDesktop = data?.desktop ?? true;
  const deviceKey = isMobileDevice ? 'mobile' : isTablet ? 'tablet' : 'desktop';

  if (
    (deviceKey === 'mobile' && !parentMobile) ||
    (deviceKey === 'tablet' && !parentTablet) ||
    (deviceKey === 'desktop' && !parentDesktop) ||
    (selectedLocale === 'en-GB' && !data?.en_GB) ||
    (selectedLocale === 'en-EU' && !data?.en_EU)
  ) {
    return null;
  }

  const shippingBannerContent = data?.data?.dataSource?.ShippingBannerLinks;
  return (
    <>
      <ShippingBanner shippingBannerContent={shippingBannerContent} />
    </>
  );
};

export default ShippingBannersTastic;
